import { Link } from '@wbk/config';
import { WebSection } from '@wbk/contentful/api';
import { Button, ImageWithPlaceholder, Typography } from '@wbk/ui';
import ScrollTitle from '@/components/ui/ScrollTitle';
import { isExternalUrl } from '@/utils/redirect';
import useLocalization from '@/context/localization/useLocalization';

type Props = {
  section?: WebSection;
};

const RecommendedForYou = ({ section }: Props) => {
  const { locale } = useLocalization();

  if (!section?.contentCollection?.items.length) return null;

  return (
    <div className='container-padding container'>
      <div className='container px-3 xl:px-0'>
        <div className='space-y-6'>
          <ScrollTitle title={section?.title || ''} />
          <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3'>
            {section?.contentCollection?.items.map((item, index) => {
              if (item?.__typename !== 'WebCard') return <div key={index} />;
              const isExternalLink = isExternalUrl(item?.href || '');
              const href = !isExternalLink
                ? `/${locale}/${item?.href?.replace(/^\/+/, '') || ''}`
                : item?.href;

              return (
                <div
                  className='flex items-center gap-4 rounded-[14px] border border-white/10 p-4 shadow-sm transition-all duration-150 hover:border-white/20'
                  key={index}
                >
                  <div className='rounded-xl bg-white/10 p-8'>
                    <ImageWithPlaceholder
                      src={item?.image?.url || ''}
                      alt={item?.image?.title || 'Guide Image'}
                      className='h-8 w-8 object-cover'
                      draggable={false}
                    />
                  </div>
                  <div className='flex flex-1 flex-col gap-4'>
                    <div className='flex flex-col'>
                      <Typography as='h4' className='!text-body-S md:!text-body-M font-semibold'>
                        {item?.title}
                      </Typography>
                      <Typography as='p' className='!text-body-XXS md:!text-body-XS'>
                        {item?.subtitle}
                      </Typography>
                    </div>

                    <Button
                      as={Link}
                      to={href || '#'}
                      target={isExternalLink ? '_blank' : undefined}
                      className='!text-body-XS md:!text-body-S w-full rounded-full py-1 font-bold capitalize md:w-auto'
                    >
                      {item?.buttonLabel}
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendedForYou;
